import React from 'react';
import { FieldProps, FormikProps, useFormikContext } from 'formik';
import { Field } from 'formik';
import { CircularProgress, InputBaseProps } from '@mui/material';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { SubmitButton } from './SubmitButton';

interface CustomComponentProps extends Partial<InputBaseProps> {
  label?: any;
  name?: string;
  Component: React.ComponentType<any>;
  isCustom?: boolean;
}

type FieldsType = {
  fields: Array<CustomComponentProps>;
  submitText: string;
  isCustom?: boolean;
  isLoading?: boolean;
};

interface FormFieldProps extends FieldProps {
  Component: React.ComponentType<any>;
  isCustom?: boolean;
  id?: string;
}

export const FormField = ({ field, form, ...props }: FormFieldProps) => {
  const { Component, id, ...rest } = props;
  const { errors, isValid }: FormikProps<{ [key: string]: string }> = useFormikContext();
  return <Component {...field} {...rest} id={id} size="small" error={!isValid && !!errors[field.name]} sx={{ minHeight: '40px' }} />;
};

export const GenericFields: React.FC<FieldsType> = ({ fields, submitText, isLoading: localIsLoading }) => {
  const { isValid }: FormikProps<{ [key: string]: string }> = useFormikContext();
  const { isLoading } = useTypedSelector((state) => state.global);
  const { isLoading : itemLoading } = useTypedSelector((state) => state.mapItems);
  const finalIsLoading = localIsLoading || isLoading || itemLoading;

  return (
    <>
      {fields.map(({ name, type = 'text', label, Component, isCustom, ...rest }) => {
        return (
          <div className="field-list" key={name}>
            <label htmlFor={name} className="data-name">
              <span>{label}</span>
            </label>
            {isCustom ? (
              <Component {...rest} />
            ) : (
              <Field
                {...rest}
                disabled={finalIsLoading}
                name={name}
                type={type}
                Component={Component}
                component={FormField}
                id={name}
              />
            )}
          </div>
        );
      })}
      <div className="field-list submit-button" style={{ paddingTop: '0.5rem' }}>
        <SubmitButton variant="outlined" type="submit" disabled={finalIsLoading || !isValid}>
          {finalIsLoading ? <CircularProgress size={24} color="inherit" /> : submitText}
        </SubmitButton>
      </div>
    </>
  );
};
